const mixin = {
    methods:{
        getValidationState: ({ dirty, validated, valid = null }) => {
            return dirty || validated ? valid : null;
        }
    }
};

export default mixin;